const wrapText = (context, text, x, y, maxWidth, lineHeight) => {
  let words = text.split(' ')
  let line = ''

  for (let n = 0; n < words.length; n++) {
    let testLine = line + words[n] + ' '
    let metrics = context.measureText(testLine)
    let testWidth = metrics.width
    if (testWidth > maxWidth && n > 0) {
      context.fillText(line, x, y)
      line = words[n] + ' '
      y += lineHeight
    }
    else {
      line = testLine
    }
  }
  context.fillText(line, x, y)
}

const countLineWrapText = (context, text, maxWidth) => {
  let words = text.split(' ')
  let line = ''
  let lineCount = 1
  for (let n = 0; n < words.length; n++) {
    let testLine = line + words[n] + ' '
    let metrics = context.measureText(testLine)
    let testWidth = metrics.width
    if (testWidth > maxWidth && n > 0) {
      line = words[n] + ' '
      lineCount += 1
    }
    else {
      line = testLine
    }
  }
  return lineCount
}

export {
  wrapText,
  countLineWrapText
}


// WEBPACK FOOTER //
// ./src/utils/index.js